import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
// import { Button } from 'web-ui-components/lib/atoms/buttons';
import withContent from '../../../containers/withContent';
import pageContent from '../Payment/payment.content';
import { getPayment } from '../../states/selectors';

const mapState = (state) => ({
	payment: getPayment(state),
});

export const Submitted = () => (
	<div className="c-o-list-payment__card c-o-card c-o-card--muted c-o-card--bordered">Payment Submitted</div>
);

Submitted.propTypes = {
	payment: PropTypes.shape({}),
};

export default compose(connect(mapState), withContent({ content: pageContent }))(Submitted);
